






































import {Component, Prop, Watch, Provide, Vue} from 'vue-property-decorator'
import {$, Helper} from 'simpli-web-sdk'
import {TypeWebhook} from '@/model/resource/TypeWebhook'
import {InputTypeWebhookSchema} from '@/schema/resource/TypeWebhook/InputTypeWebhookSchema'

@Component
export default class PersistTypeWebhookView extends Vue {
  @Prop() id?: string

  @Provide('validator') validator = this.$validator

  schema = new InputTypeWebhookSchema()
  typeWebhook = new TypeWebhook()

  async created() {
    await this.populate()
  }

  async populate() {
    const id = Number(this.id) || null

    if (id) {
      await this.typeWebhook.getTypeWebhook(id)
    }

    $.await.done('getTypeWebhook')
  }

  async persist() {
    const isValid = await this.validator.validateAll()

    if (!isValid) {
      Helper.abort('system.error.validation')
    }

    await this.typeWebhook.persistTypeWebhook()
    await Helper.successAndPush('system.success.persist', '/type-webhook/list')
  }
}
